// @flow
import api from 'tim-api';
import {
  gadget as gadgetEndpoint,
  gadgetCategory as gadgetCategoryEndpoint
} from 'endPoints';

export const state: Object = {
  gadgets: [],
  gadgetCategories: []
};

export const getters = {
  gadgets: (state: Object) => state.gadgets,
  gadgetCategories: (state: Object) => state.gadgetCategories
};

export const mutations = {
  SET_GADGET(state: Object, gadgets: Array<Object>) {
    state.gadgets = gadgets;
  },
  SET_GADGET_CATEGORY(state: Object, gadgetCategories: Array<Object>) {
    state.gadgetCategories = gadgetCategories;
  }
};

export const actions = {
  fetchGadget({ commit }: Action, brandId: Number) {
    return api.get(`${gadgetEndpoint}?brand=${brandId}`).then(({ data }) => {
      commit('SET_GADGET', data.data);
    });
  },
  fetchGadgetCategory({ commit }: Action) {
    return api.get(gadgetCategoryEndpoint).then(({ data }) => {
      commit('SET_GADGET_CATEGORY', data.data);
    });
  },
  fetchGadgetByCategory({ commit }: Action, categoryId: Number) {
    return api.get(`${gadgetCategoryEndpoint}/${categoryId}/gadgets`).then(({ data }) => {
      commit('SET_GADGET', data.data);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
